/* tslint:disable:no-console */
import React from 'react'
import invoke from 'lodash/fp/invoke'
import createApolloClient from './createApolloClient'
import { get } from 'lodash/fp'
import { parse } from 'shared/lib/safeJSON'

const withApolloClient = App =>
  class Apollo extends React.Component {
    static displayName = 'withApollo(App)'

    apolloClient = {}

    static async getInitialProps(ctx) {
      const {
        ctx: { req, res },
      } = ctx

      const csrf = req ? invoke('csrfToken', req) : null

      // Get Auth Token
      let token: string
      if (!process.browser) {
        token = req ? req.cookies.jwt : ''
      }

      // Get currency Cookie
      const currency = parse(get('cookies.currency')(req))

      const getCsrf = () => csrf
      const getToken = () => token
      const apollo = createApolloClient(
        {},
        {
          getCsrf,
          getToken,
          req,
          res,
          currency,
        },
      )

      let appProps = {}
      if (App.getInitialProps) {
        ctx.ctx.apolloClient = apollo
        appProps = await App.getInitialProps({ ...ctx, apolloClient: apollo })
      }

      if (res && res.finished) {
        // When redirecting, the response is finished.
        // No point in continuing to render
        return {}
      }

      // Extract query data from the Apollo store
      const apolloState = apollo.cache.extract()

      return {
        ...appProps,
        apolloState,
        csrf,
        currency,
      }
    }

    constructor(props) {
      super(props)
      const getCsrf = () => props.csrf
      const getToken = () => null
      this.apolloClient = createApolloClient(props.apolloState, {
        getCsrf,
        getToken,
        currency: props.currency,
      })
    }

    render() {
      return <App {...this.props} apolloClient={this.apolloClient} />
    }
  }

export default withApolloClient
